import { useGetUserSubscriptionResultsQuery } from '@/services/ApiService';
import { useUser } from '@/hooks/user/useUser.ts';

export const useUserSubscriptionResults = ({ skip = false }: { skip?: boolean } = {}) => {
    const { user } = useUser();
    const { data, isFetching, isLoading, isError } = useGetUserSubscriptionResultsQuery(user?.id ?? '', { skip: skip || !user?.id });

    return {
        data,
        isFetching,
        isLoading,
        isError,
    };
};
